export const GET_TENANT_SESSIONS = 'GET_TENANT_SESSIONS'
export const GET_SIGNED_UPLOAD_URL = 'GET_SIGNED_UPLOAD_URL_COMMON'
export const CONFIRM_FILE_UPLOAD = 'CONFIRM_FILE_UPLOAD_COMMON'
export const REDUX_TENANT_SESSIONS = 'REDUX_TENANT_SESSIONS'
